import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetRfidBadgeOrdersPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/rfid-badge-orders/get-rfid-badge-orders-paginated.form-default-values';
import { GetRfidBadgeOrdersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/rfid-badge-orders/get-rfid-badge-orders-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchEmspBoRfidBadgeOrderListContextProvider,
  useEmspBoRfidBadgeOrderListContext,
} from '../emsp-bo-rfid-badge-order.context';
import { EmspBoRfidBadgeOrderListFilterSearchFormController } from './emsp-bo-rfid-badge-order-list-filter-search-form/emsp-bo-rfid-badge-order-list-filter-search-form.controller';

interface EmspBoRfidBadgeOrderListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoRfidBadgeOrderListFilterSearchController = ({
  onCancel,
  onSuccess,
}: EmspBoRfidBadgeOrderListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoRfidBadgeOrderListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetRfidBadgeOrdersPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-rfid-badge-order-list-filter-search.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetRfidBadgeOrdersPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      textToSearch: fieldValues.textToSearch,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetRfidBadgeOrdersPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterSearchEmspBoRfidBadgeOrderListContextProvider data={data}>
      <EmspBoRfidBadgeOrderListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchEmspBoRfidBadgeOrderListContextProvider>
  );
};
